/**
 * Generic, reusable sticky container. Works in sync with site navigation sticky.
 * Companion template is cm-scriptlet://tpl-generic-sticky/
 */
class GenericSticky {
  vacant = false;
  triggered = false;
  constructor(stickyContainer) {
    this.sticky = stickyContainer;
    this.intersectionObserver = this.intersectionObserver.bind(this);
    this.toggleAnimation = this.toggleAnimation.bind(this);

    // initialize visibility trigger
    this.initTrigger();

    // Observe behaviour triggers
    this.initObservers();

    // When the page initially loads, it might look annoying that there is an immediate animation.
    // Therefore it's locked for a short period, so it only starts happening after user actually scrolls.
    this.toggleAnimation();
    // release animation
    setTimeout(this.toggleAnimation, 3000);
  }

  /**
   * [initTrigger description]
   */
  initTrigger() {
    // Check if element had a data attribute to tell which area should be observed
    if (this.sticky.hasAttribute('data-trigger-selector')) {
      this.trigger = document.querySelector(this.sticky.getAttribute('data-trigger-selector'));
    }
    // Fallback to custom target, if trigger wasn't found
    this.trigger = this.trigger || document.querySelector('.generic-sticky__default-trigger');

    // Check if element had a data attribute to tell should the observed element be seen or not seen?
    // Ie. when the user scrolls the screen down, the appearing or disappearing of certain element triggers sticky visibility
    if (this.sticky.hasAttribute('data-trigger-mode')) {
      switch (this.sticky.getAttribute('data-trigger-mode')) {
      // Sticky is triggered to show when the trigger area appears on screen. For example if the trigger is <main>, sticky appears as soon as part of <main> is visible
      case 'seen':
        this.triggerMode = true;
        break;

        // Default behaviour is "unseen". For example if trigger is <header>, sticky appears once header disappears
      case 'unseen':
      default:
        this.triggerMode = false;
      }
    }
  }

  /**
   * Starts observers that get notified on conditions that decide wether the sticky is shown.
   */
  initObservers() {
    // Keep an eye on target area that has to be out of the view to trigger the menu.
    this.intersectionObserver = new IntersectionObserver(this.intersectionObserver);
    this.intersectionObserver.observe(this.trigger);
  }

  /**
   * Toggles a class that sets or unsets the visibility of the sticky, based on conditions:
   * If the top nav area is vacant (this information comes from v10/navigation)
   * If the trigger target area intersection rule allows. (Depending on configuration the trigger area is either seen or not seen on screen)
   */
  setVisibility() {
    this.sticky.classList.toggle('generic-sticky--visible', this.triggered);
  }

  /**
   * observer method passed to intersectionObserver
   * @param  {IntersectionObserverEntry[]} entries https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry
   */
  intersectionObserver(entries) {
    const [entry] = entries;
    this.triggered = entry.isIntersecting === this.triggerMode;
    this.setVisibility();
  }
  /**
   * When the page initially loads, it might look annoying that there is an immediate animation.
   * Therefore it's locked for a short period, so it only starts happening after user actually scrolls.
   * This method simply toggles the animation off and on. Called in constructor.
   */
  toggleAnimation() {
    this.sticky.classList.toggle('generic-sticky--no-animation');
  }

  /**
   * static initialization method which finds and launches observable sticky note.
   */
  static init() {
    const stickyContainers = document.querySelectorAll('.generic-sticky');
    if (stickyContainers.length === 1) {
      new GenericSticky(stickyContainers[0]);
    } else if (stickyContainers.length > 1) {
      // Don't know how to handle a situation where there are more than on sticky.
      // For one sticky it's clear: just show when the menu isn't showing. For two? Who knows.
      console.log('generic-sticky.js found more than 1 sticky containers. Unexpected, don\'t know what to do.');
    }
  }
}

export default GenericSticky;
